import { render, staticRenderFns } from "./Emedica.vue?vue&type=template&id=7b83c46e"
import script from "./Emedica.vue?vue&type=script&lang=js"
export * from "./Emedica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports